<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../stores/rcpMng.store";
    import { login_id } from "../stores/auth.store";
    import Header from "../components/Header.svelte";

    let barcodeInput_1;
    let barcodeInputValue_1 = "";
    let scanTimeout;
    let interval;
    let isPaused = false;

    let getDate = new Date().toISOString().slice(0, 10); // 입고일자

    // 발주전표(거래명세서) 바코드 리딩
    let barcodeList = [];
    let order_no = "";
    let bcnc_nm = "";
    let order_sn = "";
    let order_de = "";

    let total_qy = 0; // 발주 수량 total
    let total_inpt_qy = 0; // 입고 수량 total

    // 발주정보조회 팝업창
    let detailList = [];

    function manageFocus() {
        if (isPaused) return;

        if (barcodeInputValue_1 === "") {
            barcodeInput_1.focus();
            barcodeInput_1.click();
        }
    }

    onMount(() => {
        interval = setInterval(manageFocus, 1000);

        apiGetRcpMngDetail();
    });

    onDestroy(() => {
        clearInterval(interval);
        clearTimeout(scanTimeout);
    });

    function handleFocus() {
        isPaused = true;
    }

    function handleBlur(order_sn, updatedValue) {
        console.log(order_sn);
        console.log(updatedValue);
        barcodeList = barcodeList.map((data) =>
            data.order_sn === order_sn
                ? { ...data, wrhousng_qy: updatedValue }
                : data
        );

        reallocation();
        isPaused = false;
    }

    function reallocation() {
        total_inpt_qy = 0;

        for (let i = 0; i < barcodeList.length; i++) {
            barcodeList[i].id = i + 1;
            barcodeList[i].order_sn = i + 1;
            total_inpt_qy += Number(barcodeList[i].wrhousng_qy);
        }
    }

    function inputBarcode(event) {
        clearTimeout(scanTimeout); // 입력 발생 시 타임아웃 초기화

        scanTimeout = setTimeout(async function () {
            if (
                event.target.id === "barcode_1" ||
                barcodeInputValue_1.trim() === ""
            ) {
                if (barcodeInputValue_1.trim() !== "") {
                    // 발주서 바코드 리딩
                    const response =
                        await api.apiGetRcpMng(barcodeInputValue_1);

                    if (response == "") {
                        barcodeInputValue_1 = "";
                        return;
                    }

                    order_no = barcodeInputValue_1;
                    bcnc_nm = response[0].bcnc_nm;
                    order_de = response[0].order_de;

                    barcodeList = [
                        ...response.map((item, index) => {
                            total_qy += item.qy;
                            total_inpt_qy += item.wrhousng_qy;

                            return {
                                id: barcodeList.length + index + 1,
                                order_sn: item.order_sn,
                                item_nm: item.item_nm,
                                qy: item.qy,
                                wrhousng_qy: item.wrhousng_qy,
                            };
                        }),
                    ];
                }
            }
        }, 900);
    }

    function chk_on(id) {
        var del_num_tr = document.getElementById(id);
        var del_num = id.split("tr_")[1];
        var del_num_on = "chk_" + del_num;
        var del_num_chk = document.getElementById(del_num_on);

        if (del_num_tr.classList.contains("on")) {
            del_num_tr.classList.remove("on");
            del_num_chk.checked = false;
        } else {
            del_num_tr.classList.add("on");
            del_num_chk.checked = true;
        }
    }

    function deleteAll() {
        barcodeInputValue_1 = "";
        order_no = "";
        bcnc_nm = "";
        order_de = "";
        total_qy = 0;
        total_inpt_qy = 0;
        barcodeList = [];
    }

    async function postRcpMng() {
        if (barcodeList.length == 0) {
            alert("발주 전표를 먼저 스캔해주세요.");
            return;
        }

        if (!(await api.apiPostRcpMng(order_no, getDate, barcodeList))) {
            return;
        }

        alert("입고 등록되었습니다.");

        deleteAll();
    }

    function pop() {
        document.querySelector(".background").className = "background show-use";
    }

    function pop_close() {
        document.querySelector(".background").className = "background";
    }

    async function apiGetRcpMngDetail() {
        const response = await api.apiGetRcpMngDetail();

        detailList = [
            ...response.map((item, index) => ({
                id: detailList.length + index + 1,
                order_no: item.order_no,
                order_de: item.order_de,
                bcnc_nm: item.bcnc_nm,
            })),
        ];
    }

    async function select_order(input_order_no) {
        barcodeInputValue_1 = input_order_no;

        const response = await api.apiGetRcpMng(barcodeInputValue_1);

        if (response == "") {
            barcodeInputValue_1 = "";
            return;
        }

        order_no = barcodeInputValue_1;
        bcnc_nm = response[0].bcnc_nm;
        order_de = response[0].order_de;

        barcodeList = [
            ...response.map((item, index) => {
                total_qy += item.qy;
                total_inpt_qy += item.wrhousng_qy;

                return {
                    id: barcodeList.length + index + 1,
                    order_sn: item.order_sn,
                    item_nm: item.item_nm,
                    qy: item.qy,
                    wrhousng_qy: item.wrhousng_qy,
                };
            }),
        ];

        pop_close();
    }
</script>

<Header />

<div class="menu-title">
    <p class="info-title" style="text-align: center;">입 고 관 리</p>
</div>

<input
    placeholder="발주전표(발주서) 바코드"
    bind:this={barcodeInput_1}
    bind:value={barcodeInputValue_1}
    on:input={inputBarcode}
    id="barcode_1"
    type="text"
    inputmode="none"
    style="touch-action: manipulation;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
    clip-path: inset(100%);"
/>

<!-- style="touch-action: manipulation;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
    clip-path: inset(100%);" -->

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="main-wrap">
    <div class="top-info">
        <div class="top-info-wrap">
            <div class="top-info-in">
                <p class="top-info-l">입고일자</p>
                <p class="top-info-r">{getDate}</p>
                <p class="btn-in" on:click={pop}>조회</p>
            </div>
            <div class="top-info-in">
                <p class="top-info-l">발주일자</p>
                <p class="top-info-r">{order_de}</p>
            </div>
            <div class="top-info-in">
                <p class="top-info-l">발주번호</p>
                <p class="top-info-r">{order_no}</p>
            </div>
            <div class="top-info-in">
                <p class="top-info-l">거래처명</p>
                <p class="top-info-r">{bcnc_nm}</p>
            </div>
        </div>
    </div>

    <div class="list-dtl-wrap scroll-custom">
        <table>
            <tbody>
                <tr>
                    <th class="chk-box">checkbox</th>
                    <th>순번</th>
                    <th>품명</th>
                    <th>발주수량</th>
                    <th>입고수량</th>
                </tr>

                {#each barcodeList as data}
                    <tr>
                        <td>{data.order_sn}</td>
                        <td>{data.item_nm}</td>
                        <td>{data.qy}</td>
                        <td
                            ><input
                                type="text"
                                inputmode="none"
                                style="text-align: center; width: 100%;"
                                on:focus={handleFocus}
                                on:blur={(e) => {
                                    handleBlur(data.order_sn, e.target.value);
                                }}
                                on:keydown={(e) => {
                                    e.key === "Enter"
                                        ? handleBlur(
                                              data.order_sn,
                                              e.target.value
                                          )
                                        : (barcodeList = barcodeList.map(
                                              (item) =>
                                                  item.order_sn ===
                                                  data.order_sn
                                                      ? {
                                                            ...item,
                                                            wrhousng_qy:
                                                                e.target.value,
                                                        }
                                                      : item
                                          ));
                                }}
                                value={data.wrhousng_qy == ""
                                    ? "0"
                                    : data.wrhousng_qy}
                            /></td
                        >
                    </tr>
                {/each}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2">총계</td>
                    <td>{total_qy}</td>
                    <td>{total_inpt_qy}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div class="btn-h-wrap">
        <p on:click={postRcpMng}>입고등록</p>
        <p
            class="del-btn"
            on:click={() => {
                deleteAll();
            }}
        >
            초기화
        </p>
    </div>

    <!-- 발주 정보 조회 팝업 -->
    <div class="background">
        <div class="window">
            <div class="popup">
                <div class="popup-hd">
                    <p>발주 정보 조회</p>
                    <img
                        alt=""
                        src="resource/img/ico_close.png"
                        class="popup-close"
                        on:click={pop_close}
                    />
                </div>

                <div class="list-dtl-wrap list-dtl-wrap-pop" id="pop">
                    <table style="border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <th>발주번호</th>
                                <th>발주일자</th>
                                <th>거래처명</th>
                            </tr>

                            {#each detailList as data}
                                <tr
                                    on:click={() => {
                                        select_order(data.order_no);
                                    }}
                                >
                                    <td>{data.order_no}</td>
                                    <td>{data.order_de}</td>
                                    <td>{data.bcnc_nm}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
